export default __webpack_public_path__ + "static/media/leftComponentBar@2x.324fb5d1.png";